const YEAR_DECLENSION = {
    DEFAULT: 'let',
    SINGLE: 'rok',
    MULTIPLE: 'roky',
};

// ### Function returns proper years string (czech declension)

export const formatYears = (value: string | null) => {
    if (value === null || value === '') return;

    const number = parseInt(value);
    if (isNaN(number)) return;

    if (number === 1) {
        return YEAR_DECLENSION.SINGLE;
    } else if (number >= 2 && number <= 4) {
        return YEAR_DECLENSION.MULTIPLE;
    } else {
        return YEAR_DECLENSION.DEFAULT;
    }
};
